import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface PriorityBadgeProps {
  priority: 'low' | 'medium' | 'high' | 'critical' | 'P0' | 'P1' | 'P2';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const priorityStyles = {
  low: { bg: 'bg-neutral-light', text: 'text-neutral-dark' },
  medium: { bg: 'bg-info/10', text: 'text-info' },
  high: { bg: 'bg-warning/10', text: 'text-warning' },
  critical: { bg: 'bg-error/10', text: 'text-error' },
  P0: { bg: 'bg-error/10', text: 'text-error' },
  P1: { bg: 'bg-warning/10', text: 'text-warning' },
  P2: { bg: 'bg-info/10', text: 'text-info' },
};

const priorityLabelKeys: Record<string, string> = {
  low: 'priority.low',
  medium: 'priority.medium',
  high: 'priority.high',
  critical: 'priority.critical',
  P0: 'priority.critical',
  P1: 'priority.high',
  P2: 'priority.medium',
};

export function PriorityBadge({ priority, size = 'md', className }: PriorityBadgeProps) {
  const { t } = useTranslation('operator');
  const styles = priorityStyles[priority] || priorityStyles.medium;
  const labelKey = priorityLabelKeys[priority] || 'priority.medium';

  const sizes = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
    lg: 'px-2.5 py-1 text-sm',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        styles.bg,
        styles.text,
        sizes[size],
        className
      )}
    >
      {t(labelKey)}
    </span>
  );
}
